import React from 'react'

const TriangleUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M0 21.3h28.3L14.2 7.1z" />
  </svg>
)

export default TriangleUp
